import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLazyViewUserPlantInvertersQuery } from "../../../../../redux/api/generation/generationAPI";
import SiteDeviceLogItem from "../../../../../shared/components/site-device-log-item/site-device-log-item";
import IViewUserSolarPlantInvertersResponseDTO from "../../../../../shared/oversight-core/dtos/response-dtos/view-user-solar-plantInverters-response-dto";
import { ESolarServiceProvider } from "../../../../../shared/oversight-core/enums/solar-service-provider";
import { IBatteryInverterView } from "../../../../../shared/oversight-core/interfaces/battery-inverter-view";
import { IExtendGenericSolarPlantInverters } from "../../../../../shared/oversight-core/interfaces/generic-page-solar-plant-inverter-view";
import { IGridInverterView } from "../../../../../shared/oversight-core/interfaces/grid-inverter-view";
import InverterInfoCard from "../../../../../shared/oversight-core/shared-components/inverter-info-card/inverter-info-card";
import AppButton from "../../../../../shared/oversight-core/ui-elements/buttons/app-button/app-button";
import Pagination from "../../../../../shared/oversight-core/ui-elements/pagination/pagination";
import SpinnerModal from "../../../../../shared/oversight-core/ui-elements/spinner/spinner";

interface IProps {
  plantId: string;
  serviceProvider: ESolarServiceProvider;
}

const SiteDevices = (props: IProps) => {
  const { plantId, serviceProvider } = props;

  const [goodWeGridInverters, setGoodWeGridInverters] = useState<
    IGridInverterView[]
  >([]);
  const [goodWeBatteryInverters, setGoodWeBatteryInverters] = useState<
    IBatteryInverterView[]
  >([]);
  const [vrmInverters, setVrmInverters] = useState<
    IExtendGenericSolarPlantInverters[]
  >([]);
  const [totalElements, setTotalElements] = useState(0);
  const [filter, setFilter] = useState({ pageNumber: 0 });

  const [triggerUserPlantInverters, { isFetching }] =
    useLazyViewUserPlantInvertersQuery();

  useEffect(() => {
    if (plantId) {
      triggerUserPlantInverters({
        plantId: plantId,
        pageNumber: filter.pageNumber,
        pageSize: 5,
      })
        .unwrap()
        .then((res: IViewUserSolarPlantInvertersResponseDTO) => {
          setGoodWeGridInverters(res.genericPage.elements[0].gridInverterViews);
          setGoodWeBatteryInverters(
            res.genericPage.elements[0].batteryInverterViews
          );
          setVrmInverters(res.genericPage.elements);
          setTotalElements(res.genericPage.totalElements);
        })
        .catch(() => {
          setTotalElements(0);
        });
    }
  }, [triggerUserPlantInverters, plantId, filter]);

  return (
    <div className="position-relative">
      <Row>
        <Col className="col-auto">
          <AppButton
            iconName="open_in_new"
            iconWeight={700}
            text={`Open in ${
              serviceProvider === ESolarServiceProvider.VRM
                ? `Victron VRM`
                : `GoodWe`
            }`}
            variant="transparentWithBorder"
            className="font-size-14"
            onClick={() =>
              serviceProvider === ESolarServiceProvider.VRM
                ? window.open("https://vrm.victronenergy.com/", "_blank")
                : window.open("https://www.semsportal.com/", "_blank")
            }
          />
        </Col>
      </Row>
      {serviceProvider === ESolarServiceProvider.GOODWE && (
        <Row className="flex-column gy-2 mt-4 mx-0">
          {goodWeGridInverters && goodWeGridInverters.length > 0 ? (
            goodWeGridInverters.map((goodWeGridInverter, index) => (
              <InverterInfoCard key={index} gridInverter={goodWeGridInverter} />
            ))
          ) : goodWeBatteryInverters && goodWeBatteryInverters.length > 0 ? (
            goodWeBatteryInverters.map((goodWeBatteryInverter, index) => {
              return (
                <InverterInfoCard
                  key={index}
                  batteryInverter={goodWeBatteryInverter}
                />
              );
            })
          ) : (
            <>
              {!isFetching && (
                <div className="mt-4 container-dash text-center text-light font-weight-400 font-size-14">
                  There are no inverters
                </div>
              )}
            </>
          )}
        </Row>
      )}
      {serviceProvider === ESolarServiceProvider.VRM && (
        <Row className="flex-column gy-2 mt-4">
          {vrmInverters && vrmInverters.length > 0 ? (
            vrmInverters.map((vrmInverter, index) => {
              return (
                <Col key={index}>
                  <SiteDeviceLogItem inverter={vrmInverter} />
                </Col>
              );
            })
          ) : (
            <>
              {!isFetching && (
                <div className="mt-4 container-dash text-center text-light font-weight-400 font-size-14">
                  There are no inverters
                </div>
              )}
            </>
          )}
        </Row>
      )}
      <Row>
        <Col>
          <Pagination
            itemsPerPage={5}
            length={totalElements}
            currentPage={filter.pageNumber + 1}
            updateCurrentPage={(pn) => {
              setFilter((ps) => ({ ...ps, pageNumber: pn - 1 }));
            }}
          />
        </Col>
      </Row>
      <SpinnerModal show={isFetching} />
    </div>
  );
};

export default SiteDevices;
